import { z } from "zod";
import { ResponsiveImageSchema } from "./components/Image";
import { ActionSchema } from "./schemas/Actions";
import { colorPaletteValidNames } from "./skins/types";
export const BladeCommonSchema = z.object({
    layout: z.string().optional(),
    fragmentId: z.string().optional(),
    palette: z.enum(colorPaletteValidNames).optional(),
});
export const AnalyticsSchema = z.object({
    contentId: z.string(),
    contentLocale: z.string(),
    contentCategory: z.string().optional(),
    version: z.number().optional(),
    rev: z.string().optional(),
    publishDate: z.string(),
});
export const LogoSchema = z.object({
    image: ResponsiveImageSchema,
    action: ActionSchema.optional(),
});
export const LinkSchema = z.object({
    title: z.string(),
    url: z.string(),
    accessibilityText: z.string(),
    image: ResponsiveImageSchema.optional(),
    analytics: AnalyticsSchema.optional(),
});
export const ContentSchema = z.object({
    title: z.string(),
    description: z.string().optional(),
    url: z.string().optional(),
    action: ActionSchema.optional(),
    image: ResponsiveImageSchema.optional(),
    analytics: AnalyticsSchema.optional(),
    publishedAt: z.string().optional(),
});
export const BackdropBladeArgSchema = z.object({
    background: ResponsiveImageSchema.optional(),
    foreground: ResponsiveImageSchema.optional(),
});
export const TabFieldLinkSchema = z.object({
    title: z.string().optional(),
    url: z.string(),
    accessibilityText: z.string().optional(),
    analytics: AnalyticsSchema.optional(),
});
export const TabFieldSchema = z.object({
    heading: z.string(),
    value: z.string(),
    link: TabFieldLinkSchema.optional(),
    type: z.union([z.literal("long"), z.literal("short")]).optional(),
});
export const TabGroupSchema = z.object({
    heading: z.string(),
    subheading: z.string().optional(),
    fields: z.array(TabFieldSchema),
});
export const TabSchema = z.object({
    heading: z.string(),
    id: z.string(),
    groups: z.array(TabGroupSchema),
});
//# sourceMappingURL=types.js.map